module.exports = __webpack_public_path__ + "media/stylesheets/images/marker-icon-2x-orange-a5fcf3903a95aba7d524cdb6ba6d5085.png";